import { render, staticRenderFns } from "./ftpImportedOrders.vue?vue&type=template&id=1a340e88&"
import script from "./ftpImportedOrders.vue?vue&type=script&lang=js&"
export * from "./ftpImportedOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports